import styled from 'styled-components'
import { bp, font } from 'lib/core/resources/helpers/styled'

export const CompareLink = styled.a<{ hasIcon?: boolean }>`
  display: flex;
  align-items: center;
  color: ${props => props.theme.palette.general.strong};

  span {
    margin-left: 4px;
  }

  ${props => !props.hasIcon && `
    text-decoration: underline;
    position: absolute;
    left: 18px;
    bottom: 14px;
  `}
  ${bp('sm')`
    font: ${font('default', 'light', '13px/1')};
  `}
`
